import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';

import {Model as SequencePrimer} from 'biojs/SequencePrimer';
import {gc} from 'biojs/Util';
import {Primer3Direction} from 'molbio/MolBioConstants';
import * as sequtil from 'molbio/SeqUtil';
import getTestProps from 'test/lib/cypress/getTestProps';

export interface Primer3RowProps {
  // TODO(TypeScript): Figure out and define types for all of these.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  model: any;
  primers: {[direction in Primer3Direction]?: SequencePrimer};
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  sequence: any;
}

export default function Primer3Row({model, primers, sequence}: Primer3RowProps): JSX.Element {
  return (
    <>
      <tr className="forward">
        <td>
          <input
            type="checkbox"
            className="primer3Row-allSelected"
            {...getTestProps({component: 'Primer3Row', element: 'rowCheckbox'})}
          />
        </td>
        {/* TODO: Switch to using Number.isNaN / null checks */}
        {/* eslint-disable-next-line no-restricted-globals */}
        {!isNaN(model.get('penalty')) ? (
          <td className="text-center">{parseFloat(model.get('penalty')).toFixed(3)}</td>
        ) : (
          <td />
        )}
        <td>
          <input
            type="checkbox"
            className={classNames('primer3Row-forwardSelected', css(styles.primerCheckbox))}
          />
          FWD
        </td>
        <td className="text-center">
          {(gc(model.get('forward').bases(), model.get('forward').nucleotideType()) * 100).toFixed(1)}%
        </td>
        <td className="text-center">
          {model.get('forward').meltingTemperature().toFixed(1)}
          &deg;
        </td>
        <td className="text-center">
          {sequtil.modelStartToDisplay(model.get('forward').get('start'), sequence.startIndex())}-
          {sequtil.modelEndToDisplay(
            model.get('forward').get('end'),
            sequence.length(),
            sequence.startIndex()
          )}
        </td>
        <td className="text-center">{model.get('forward').get('bases').length}</td>
        <td className="text-center">{model.get('product_size')}</td>
        <td
          className="mono"
          // oxlint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{__html: primers.forward!.basesHtml(sequence)}}
        />
        <td>
          <a className="edit">Edit</a>
        </td>
      </tr>
      {model.get('probe') && (
        <tr className="probe">
          <td />
          <td />
          <td>
            <input
              type="checkbox"
              className={classNames('primer3Row-probeSelected', css(styles.primerCheckbox))}
            />
            PROBE
          </td>
          <td className="text-center">
            {(gc(model.get('probe').bases(), model.get('probe').nucleotideType()) * 100).toFixed(1)}%
          </td>
          <td className="text-center">
            {model.get('probe').meltingTemperature().toFixed(1)}
            &deg;
          </td>
          <td className="text-center">
            {sequtil.modelStartToDisplay(model.get('probe').get('start'), sequence.startIndex())}-
            {sequtil.modelEndToDisplay(
              model.get('probe').get('end'),
              sequence.length(),
              sequence.startIndex()
            )}
          </td>
          <td className="text-center">{model.get('probe').get('bases').length}</td>
          <td />
          <td
            className="mono"
            // oxlint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{__html: primers.probe!.basesHtml(sequence)}}
          />
          <td />
        </tr>
      )}
      <tr className="reverse">
        <td />
        <td />
        <td>
          <input
            type="checkbox"
            className={classNames('primer3Row-reverseSelected', css(styles.primerCheckbox))}
          />
          REV
        </td>
        <td className="text-center">
          {(gc(model.get('reverse').bases(), model.get('reverse').nucleotideType()) * 100).toFixed(1)}%
        </td>
        <td className="text-center">
          {model.get('reverse').meltingTemperature().toFixed(1)}
          &deg;
        </td>
        <td className="text-center">
          {sequtil.modelStartToDisplay(model.get('reverse').get('start'), sequence.startIndex())}-
          {sequtil.modelEndToDisplay(
            model.get('reverse').get('end'),
            sequence.length(),
            sequence.startIndex()
          )}
        </td>
        <td className="text-center">{model.get('reverse').get('bases').length}</td>
        <td />
        <td
          className="mono"
          // oxlint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{__html: primers.reverse!.basesHtml(sequence)}}
        />
        <td />
      </tr>
    </>
  );
}

const styles = StyleSheet.create({
  primerCheckbox: {
    marginRight: 4,
  },
});
